<template>
    <ui-dropdown placement="bottom-start" menu-class="w-full max-w-lg">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class="p-3 max-h-64 overflow-y-auto">
                <!-- Empty State. -->
                <div v-if="!query" class="text-gray-500 text-sm">
                    Start typing to search for known contact...
                </div>

                <div v-else class="space-y-6">
                    <div v-if="filteredExternalUseres.length > 0">
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">Existing external users</div>
                        <div class="space-y-1">
                            <button
                                v-for="externalUser in filteredExternalUseres"
                                class="flex items-center space-x-2 text-left w-full rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                :title="externalUser.name"
                                @click="selectContact(externalUser, close)"
                            >
                                <div class="truncate flex-1 flex flex-col">
                                    <div class="truncate w-full">{{ externalUser.emailAddress }}</div>
                                    <div class="truncate w-full text-xs text-gray-500" v-if="externalUser.name">
                                        {{ externalUser.name }}
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div v-else class="text-gray-500 text-sm">
                        No matching contacts found.
                    </div>

                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>
export default {
    props: {
        top: Boolean,
        existingUsers: [],
        rams: Object|Function,
        buttonClass: {
            type: String,
            default: 'text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600',
        },
    },
    data() {
        return {
            query: '',
        }
    },
    computed: {
        filteredExternalUseres() {
            return this.existingUsers.filter((i) => {
                return !this.rams.externalInvites.find((invite) => invite.email === i.emailAddress)
            }).filter(this.matchContact).sort((a, b) => {
                    let score = 0;
                    score += a.emailAddress ? 0 : 1;
                    score += b.name ? 0 : -1;
                    return score;
                }).slice(0, 100);
        },
    },
    methods: {
        scope(dropdownScope) {
            return {
                query: this.query,
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        setQuery(query) {
            this.query = query
            if (!this.query) return
        },
        matchContact(externalUser) {
            const query = this.query.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            let ret = query.every((token) => {
                return (externalUser.emailAddress + '|' + externalUser.name).toLowerCase().includes(token);
            });
            return ret;
        },
        selectContact(externalUser, close) {
            this.$emit('selected:externalUser', externalUser);
            this.query = externalUser.emailAddress;
            close();
        },
    },
}
</script>
